export default __webpack_public_path__ + "static/media/profileCard.4a63ac22.png";